/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableAvatar } from 'ui/Avatar/Avatar';
import { ColumnType, ParseTableColumns } from './Table.types';
import { formatDate } from 'utils/date';

export const namesParseColumns: ParseTableColumns<any> = {
    avatar: TableAvatar,
    birthday: formatDate
};

export const typesParseColumns: Record<
    ColumnType,
    (value: any) => React.ReactNode
> = {
    date: formatDate,
    avatar: TableAvatar
};
